<template>
    <div class="policies-container pb-50px flex justify-center items-center w-100%">
        <AppHeader title="Privacy Policy" :show-back="true" />
        <div class="w-100% p-20px">
            <div class="flex flex-col mt-30px items-center justify-center">
                <p class="color-#FFFFFF text-center lh-14px text-12px">
                    This Privacy Policy describes how      {{ JSON.parse(parsed || '{}').AppName || 'Aishmin' }} ("we", "us", or "our")
                    collects, uses, and discloses your personal information when you use
                    the      {{ JSON.parse(parsed || '{}').AppName || 'Aishmin' }} website ("Website"). By accessing or using the Website,
                    you agree to the terms of this Privacy Policy.
                </p>
            </div>
            <div class="overflow-y-auto color-#fff">
                <div class="info-item">
                    <div class="color-#fff text-12px ">1. Information We Collect</div>
                    <p class="color-#fff lh-14px text text-10px">
                        1.1. Information You Provide: When you use the Website, you may
                        provide us with certain personal information, such as your name, email
                        address, and any other information you choose to provide.
                    </p>
                    <p class="color-#fff lh-14px text text-10px">
                        1.2. Automatically Collected Information: We may automatically collect
                        certain information about your device and usage of the Website,
                        including your IP address, browser type, operating system, and usage
                        data.
                    </p>
                </div>
                <div class="info-item">

                    <div class="color-#fff text-12px mt-10px">2. Use of Information</div>
                    <p class="color-#fff lh-14px text text-10px">
                        2.1. We may use the information we collect for the following purposes:
                        To provide, maintain, and improve the Website; To respond to your
                        inquiries and provide customer support; To communicate with you about
                        our products, services, and promotions; and To detect, prevent, and
                        address technical issues and security breaches.
                    </p>
                </div>
                <div class="info-item">

                    <div class="color-#fff text-12px mt-10px">
                        3. Disclosure of Information
                    </div>
                    <p class="color-#fff lh-14px text text-10px">
                        3.1. We may disclose your personal information in the following
                        circumstances: With your consent; To comply with applicable laws,
                        regulations, or legal process; To protect and defend our rights or
                        property; and In connection with a merger, acquisition, or sale of
                        assets.
                    </p>
                </div>
                <div class="info-item">
                    <div class="color-#fff text-12px mt-10px">5. Third-Party Links</div>

                    <p class="color-#fff lh-14px text text-10px">
                        5.1. The Website may contain links to third-party websites or services
                        that are not owned or controlled by      {{ JSON.parse(parsed || '{}').AppName || 'Aishmin' }}. We are not responsible
                        for the privacy practices or content of such third-party websites or
                        services.
                    </p>

                </div>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">6. Children's Privacy</div>
                <p class="color-#fff lh-14px text text-10px">
                    6.1. The Website is not intended for children under the age of 13, and
                    we do not knowingly collect personal information from children under
                    the age of 13. If we become aware that we have collected personal
                    information from a child under the age of 13, we will take steps to
                    delete such information.
                </p>
            </div>


            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">
                    7. Changes to Privacy Policy
                </div>
                <p class="color-#fff lh-14px text text-10px">
                    7.1. We reserve the right to modify this Privacy Policy at any time.
                    Any changes will be effective immediately upon posting on the Website.
                    Your continued use of the Website after the posting of changes
                    constitutes your acceptance of such changes.
                </p>
            </div>
            <div class="info-item">
                <div class="color-#fff text-12px mt-10px">8. Contact Us</div>
                <p class="color-#fff lh-14px text text-10px">
                    8.1. If you have any questions about this Privacy Policy, please
                    contact us at support@sai.com. By using the Website, you acknowledge
                    that you have read, understood, and agree to be bound by this Privacy
                    Policy.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import theme from '@/styles/theme';
import { AppHeader } from '@/components';
const parsed = localStorage.getItem('ai-chat-parsed')

// 政策和条款页面 - 不需要额外的数据
</script>

<style scoped lang="scss">
.policies-container {
    padding-bottom: 50px;
    background: v-bind('theme.colors.background');
    // min-height: 100vh;
}

.text {
    color: v-bind('theme.colors.textPrimary');
}

.info-item {
    padding: 10px;
    background-color: v-bind('theme.colors.backgroundQuaternary');
    margin-top: 10px;
}
</style>